/**
 * Split a newline-delimited model answer into an ordered array of entity IDs,
 * filtering out any line not in `validIds`. Garbled lines are silently dropped
 * so callers can fall back to their default ordering without error handling.
 */
export function parseRankedIds(
  answer: string,
  validIds: ReadonlySet<string>,
): string[] {
  if (!answer.trim()) return [];
  const seen = new Set<string>();
  const result: string[] = [];
  for (const line of answer.split('\n')) {
    const id = line.trim();
    if (id && validIds.has(id) && !seen.has(id)) {
      seen.add(id);
      result.push(id);
    }
  }
  return result;
}
